/* @jsx h */

import { FloorPlan, FloorPlanTable, TableStatus } from "@lemmonhq/types";
import { defineComponent, h, Ref, ref } from "vue";
import { FloorPlanItemForm } from "../FloorPlanItemForm";
import { deleteFloorPlanItem, updateFloorPlanItem } from "../utils";

export type TableSettingsProps = {
  tableStatus: TableStatus;
  floorPlan?: FloorPlan;
  planConfig?: FloorPlanTable;
  onFloorPlanChange: (fp: FloorPlan) => void;
  tables?: TableStatus[];
  isEditable?: boolean;
  activeTable: Ref<FloorPlanTable | undefined>;
};
export const TableSettings = defineComponent<TableSettingsProps>({
  name: "TableSettings",
  props: [
    "tableStatus",
    "floorPlan",
    "planConfig",
    "onFloorPlanChange",
    "tables",
    "isEditable",
    "activeTable",
  ],
  setup(props) {
    const showConfigureModal = ref(false);

    const handleDelete = () => {
      if (props.onFloorPlanChange && props.floorPlan && props.planConfig) {
        const updatedPlan = deleteFloorPlanItem(
          props.floorPlan,
          props.planConfig.id,
        );
        props.onFloorPlanChange(updatedPlan);
        props.activeTable.value = undefined;
      }
    };

    return () => {
      return (
        <div class="p-4 space-y-4">
          <div class="flex flex-col gap-2">
            <button
              onClick={() => (showConfigureModal.value = true)}
              class="btn btn-primary"
              disabled={!props.planConfig}
            >
              <span class="material-symbols-outlined">settings</span>
              Configure Item
            </button>

            <button
              onClick={handleDelete}
              class="btn btn-error"
              disabled={!props.planConfig}
            >
              <span class="material-symbols-outlined">delete</span>
              Delete
            </button>
          </div>

          {showConfigureModal.value &&
          props.planConfig &&
          props.floorPlan &&
          props.tables ? (
            <FloorPlanItemForm
              planConfig={props.planConfig}
              floorPlan={props.floorPlan}
              tables={props.tables}
              onClose={() => (showConfigureModal.value = false)}
              onSelect={(tableDef) => {
                if (props.onFloorPlanChange && props.floorPlan) {
                  const updatedPlan = updateFloorPlanItem(
                    props.floorPlan,
                    tableDef,
                  );
                  props.onFloorPlanChange(updatedPlan);
                }
                showConfigureModal.value = false;
              }}
              onUpdate={(updatedFloorPlan) => {
                if (props.onFloorPlanChange) {
                  props.onFloorPlanChange(updatedFloorPlan);
                }
                showConfigureModal.value = false;
              }}
            />
          ) : null}
        </div>
      );
    };
  },
});
